import type { ParagraphDefinition } from '@atlaskit/adf-schema';
import { p, link } from '@atlaskit/adf-utils/builders';
import { APP_CONTEXT } from '../../app/context';
import { helpUrlMapping, JSM_HELP_CENTER_URL } from './constants';

export const buildErrorMessageAdfNode = (): ParagraphDefinition => {
    const helpCenterUrl = helpUrlMapping[APP_CONTEXT.cloudId];

    if (helpCenterUrl) {
        return p(
            `For some reason, I couldn't answer. Please wait a moment and try again or you can get help from `,
            link({ href: helpCenterUrl })(helpCenterUrl)
        );
    }

    return p(
        `I’m sorry, I couldn’t find an answer to your question. Try rephrasing your question or you can get help from your Jira Service Management `,
        link({ href: JSM_HELP_CENTER_URL })('help center.')
    );
};
